<p class="fw-bold m-0">
  {{ title | translate }}
</p>
<p class="m-0">
  {{ 'operations.signErrorMessage' | translate: { fullName: signedBy, date: signedAt | baseFormatDate: true } }}
</p>
